import {
    Box,
    ButtonBase,
    Divider,
    Stack,
    styled,
    Typography,
} from "@mui/material";
import { AppTabs } from "../../components/AppTabs";
import { useState } from "react";
import DailyQuest from "../../page-sections/quest/DailyQuest";
import PartnerQuest from "../../page-sections/quest/PartnerQuest";
import useUserQuest from '../../hooks/useUserQuest'
import useUserBalances from "../../hooks/useUserBalances";
import FlexBetween from "../../components/flexbox/FlexBetween";
import FlexRowAlign from "../../components/flexbox/FlexRowAlign";
import { shortenNumber } from "../../utils/format";

export default function Quest() {
    const [tabIndex, setTabIndex] = useState(0)
    const quests = useUserQuest(0)?.userQuest
    const dailyQuests = useUserQuest(1)?.userQuest
    const { POWERBalance } = useUserBalances()

    return (
        <QuestContainer>
            <Stack sx={{ position: 'absolute', top: 0, zIndex: 97, width: '100%' }}>
                <FlexRowAlign gap={2} px={1} justifyContent="flex-start">
                    <ButtonBase onClick={() => setTabIndex(0)} sx={{ opacity: tabIndex === 0 ? 1 : 0.4, fontWeight: 700 }}>Tasks</ButtonBase>
                    <Divider orientation="vertical" sx={{ height: 10, opacity: 1 }} />
                    <ButtonBase onClick={() => setTabIndex(1)} sx={{ opacity: tabIndex === 1 ? 1 : 0.4, fontWeight: 700 }}>Partner tasks</ButtonBase>
                </FlexRowAlign>
                {
                    tabIndex === 0 ? <DailyQuest quests={quests} POWERBalance={POWERBalance} /> : ''
                }
                {
                    tabIndex === 1 ? <PartnerQuest quests={dailyQuests} POWERBalance={POWERBalance} /> : ''
                }
            </Stack>
        </QuestContainer >
    );
}

const QuestContainer = styled(Stack)(({ theme }) => ({
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: 'relative'
}));